import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toHtml from "html-react-parser";
import Breadcrums from "../../../common/breadcrumbs";
import Loader from "../../../common/loader";
import { breakWord, capitalizeFirstLetter, convertYouTubeUrl, formateDate, removeSpecialCharacter, showStatus } from "../../../../../utils/commonfunction";
import * as videoServices from "../../../services/video.services";
import { useTranslation } from "react-i18next";

const VideoView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});
  const [showVideoData, setShowVideoData] = useState({});
  const breadcrumbs = [
    { title: t("admin.faq.link_dashboard"), url: "/admin/dashboard/1" },
    { title: t("Video"), url: "/admin/cms/video/list/1" },
    { title: t("admin.faq.link_view"), url: "" },
  ];

  // const selected_language = localStorage.getItem("system_language")
  // console.log(selected_language)

  useEffect(() => {
    videoServices
      .Details(params.id)
      .then((data) => {
        setShowDefault(data && data.data ? data.data : []);
        if(data?.data?.video_type === "link") {
          setShowVideoData(data?.data?.video_link)
        } else {
          setShowVideoData(data?.data?.video)
        }
        // setShowVideoData(data?.data?.video)
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, []);


  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">{t("View Video")}</h6>
              </div>
              {showdefault && Object.keys(showdefault)?.length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>

                        <tr>
                          <th>{t("admin.faq.list_heading_title")} </th>
                          <td className="text-capitalize">
                            {showdefault && showdefault?.title
                              ? capitalizeFirstLetter(showdefault.title)
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("Category")} </th>
                          <td className="text-capitalize">
                            {showdefault && showdefault?.categories?.length > 0
                              ? showdefault.categories?.map((data) => data.category).join(", ")
                              : "N/A"}
                          </td>
                        </tr>

                      
                        <tr>
                          <th>{t("admin.faq.label_status")}</th>
                          <td>
                            {showdefault && showdefault?.status === 0
                              ? toHtml(showStatus(showdefault.status))
                              : toHtml(showStatus(showdefault.status))}
                          </td>
                        </tr>

                        <tr>
                          <th>Video type</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault?.video_type
                              ? showdefault.video_type
                              : "N/A"}
                          </td>
                        </tr>      
                         <tr>
                        <th>Thumbnail Image</th>
                        <td>
                          <img
                            src={
                              showdefault && showdefault.thumbnail_image
                                ? showdefault.thumbnail_image
                                : "N/A"
                            }
                            alt="profile"
                            style={{ height: "100px" }}
                          />
                        </td>
                      </tr>
                        <tr>
                          <th>{t("Video")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault?.video_type === "link" ? (
                              <iframe
                                width="200"
                                height="100"
                                src={convertYouTubeUrl(showVideoData)}
                                title="YouTube video player"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                              ></iframe>
                            ) : (
                              <video
                                src={showVideoData}
                                style={{ height: "100px" }}
                                controls
                              />
                            )}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("admin.list_heading.list_heading_created_date")}</th>
                          <td>
                            {showdefault && showdefault.createdAt
                              ? formateDate(showdefault.createdAt)
                              : "N/A"}
                          </td>
                        </tr>
                        {/* <tr>
                          <th>{t("admin.list_heading.list_heading_modified_date")}</th>
                          <td>
                            {showdefault && showdefault?.updatedAt
                              ? formateDate(showdefault.updatedAt)
                              : "N/A"}
                          </td>
                        </tr> */}
                      </tbody>
                    </table>
                    <h6 className="main-content-label mb-3">{t("admin.faq.label_description")}:</h6>
                    {/* <div className="">{toHtml(showdefault && showdefault.description ? showdefault.description : "N/A")}</div> */}
                    <div className="text-capitalize"
                      dangerouslySetInnerHTML={{
                        __html:
                          showdefault && showdefault?.description
                            ? showdefault.description
                            : "N/A",
                      }}
                    ></div>
                    <div className="mt-5">
                      <button
                        className="btn ripple btn-dark"
                        type="button"
                        onClick={() => navigate(-1)}
                      >
                        <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                        {t("admin.button.btn_back")}
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VideoView;
